import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { notBlank } from "../../../util/ext";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  label: {
    minWidth: 0,
    paddingRight: theme.spacing(5),
  },

  tooltip: {
    borderRadius: "20px",
    padding: "5px 12px",
    margin: "0",
  },
}));

const SidebarTreeItemLabel = props => {
  const { icon, labelText, tooltipLabel, TypographyProps, dropRef } = props;

  const classes = useStyles();
  return (
    <Grid ref={dropRef} container wrap="nowrap" alignItems="center">
      {icon && (
        <Grid item style={{ paddingRight: "15px" }}>
          {icon}
        </Grid>
      )}

      <Grid item className={classes.label}>
        {notBlank(tooltipLabel) ? (
          <Tooltip
            enterDelay={300}
            classes={{ tooltip: classes.tooltip }}
            title={tooltipLabel}
            placement="right"
          >
            <Typography noWrap {...TypographyProps}>
              {labelText}
            </Typography>
          </Tooltip>
        ) : (
          <Typography noWrap {...TypographyProps}>
            {labelText}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default SidebarTreeItemLabel;
